module.exports = __webpack_public_path__ + "img/3.9dfff2ea.png";